module.exports = __webpack_public_path__ + "img/four3Orange.eb899ca5.png";